import { Option } from "@inrev/core";
import { documentUrlQueryKey } from "@portal/api/files";
import { useCallback } from "react";
import { useGetFileUrl } from "../../../api";
import type { PDFViewerControl } from "./documentSource";

/** Downloads the original file under its original name, and says when that fails. */
export const useDocumentDownload = (control: Option<PDFViewerControl>) => {
	const { getFileUrl, fileUrlLoading, fileUrlError, resetFileUrlError } = useGetFileUrl();
	const download = useCallback(() => {
		if (Option.isNone(control)) return;
		getFileUrl({
			baseUrl: control.fetchUrl,
			asDownload: true,
			queryKey: documentUrlQueryKey(control.queryKey, "download"),
		});
	}, [control, getFileUrl]);
	return {
		download,
		canDownload: Option.isSome(control),
		downloading: fileUrlLoading,
		failed: Option.isSome(fileUrlError),
		dismissError: resetFileUrlError,
	};
};
